<template>
  <v-container>
    <div id="headersCompraSpot">
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <div
          id="idTable"
          style="overflow-x: auto; max-width: 100%;"
        >
          <table
            style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Fornecedor
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Data
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Quantidade
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Preço
                </th>
                <th
                  id="dadoMovimentacaoHeader"
                  style="text-align: center;"
                  class="black--text title"
                >
                  Valor Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in comprasSpot"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.fornecedor }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  {{ item.data }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.quantidade }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.preco }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.valorprodutos }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="mostrarTotalizador"
          class="tabela-totalizador"
        >
          <span>
            <strong>
              Total de quantidade:
              {{ quantidadeTotal }}
            </strong>
            <br>
            <strong>
              Valor total:
              {{ valorTotal }}
            </strong>
          </span>
        </div>
      </div>
    </div>
  </v-container>
</template>

    <script>
  import Compras from '../../../../services/compras'
  import eventEmit from '../core/EventoEmit'

  export default {
    name: 'CompraLeiteSpotExibicao',
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      headersCompraSpot: [
        { text: 'Fornecedor', value: 'fornecedor', class: 'black--text title' },
        { text: 'Data', value: 'data', class: 'black--text title' },
        { text: 'Quantidade', value: 'quantidade', class: 'black--text title' },
        { text: 'Preço', value: 'preco', class: 'black--text title' },
        { text: 'Valor Total', value: 'valorprodutos', class: 'black--text title' },
      ],
      comprasSpot: [],
      quantidadeTotal: 0,
      valorTotal: 0,
    }),

    computed: {
      alturaTabela () {
        const rowHeight = 48
        const headerHeight = 48
        const maxRows = 7
        if (this.comprasSpot.length === 0) {
          return headerHeight + 'px'
        } else if (this.comprasSpot.length < maxRows) {
          return this.comprasSpot.length * rowHeight + headerHeight + 'px'
        } else {
          return '350px'
        }
      },
      mostrarTotalizador () {
        return this.comprasSpot.length > 0
      },
    },

    created () {
      eventEmit.$on('set_compra_spot', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set_compra_spot', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select

        this.showcomprasSpot()
      },

      async showcomprasSpot () {
        this.loading = true
        this.comprasSpot = []

        await Compras.showComprasSpot(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.comprasSpot = resposta.data.compras.map((item) => {
              var listacomprasSpot = ({
                fornecedor: item.fornecedor,
                data: item.data,
                quantidade: this.formateNum(item.quantidade),
                preco: this.formatMoeda(item.preco),
                valorprodutos: this.formatMoeda(item.valorprodutos),
              })
              return listacomprasSpot
            })
            this.quantidadeTotal = this.formateNum(resposta.data.quantidadeTotal)
            this.valorTotal = this.formatMoeda(resposta.data.valorTotal)
          } else if (resposta.data.msg === 'Não há dados no período selecionado') {
            this.comprasSpot = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false
        })
      },
      formateNum (num) {
        return num.toLocaleString('pt-BR', { maximumFractionDigits: 0 })
      },
      formatMoeda (num) {
        return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #textotabela {
    font-size: 0.75rem !important
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  .tabela-totalizador {
    display: table;
    width: 100%;
    table-layout: fixed;
    color: black;
    border-collapse: collapse;
    border-top: 1px solid #ccc;
    font-family: inherit;
  }

  .tabela-totalizador span {
    display: table-cell;
    padding: 8px;
    vertical-align: middle;
    border-bottom: 1px solid #ddd;
    font-weight: normal;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #headersCompraSpot {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersCompraSpot {
      width: 100% !important;
    }
  }
  .totalizador td {
    font-weight: bold;
  }
</style>
